import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

export interface CaptchaResponse {
  key: string;
  img: string;
  ttl: number;
}

@Injectable({
  providedIn: 'root',
})
export class CaptchaService {
  constructor(private http: HttpClient) {}

  public getCaptcha() {
    return this.http.post<CaptchaResponse>('/v1/captcha', {});
  }
}
